export const getInitialState = (props) => {
    const {
        env: { localeInfo } = {},
        request: { path },
        user: {
            email,
            firstName,
            fullName,
            isAuthenticated,
            lastName,
            publicId: userId,
        } = {},
    } = props;

    return {
        localeInfo,
        user: {
            email,
            firstName,
            fullName,
            id: userId,
            isAuthenticated,
            lastName,
        },
        userId: userId,
    };
};
